import { useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { useAuth } from "@/contexts/AuthContext";
import { formatApiError } from "@/lib/api";
import { toast } from "sonner";
import { ChatCircleDots, ArrowLeft } from "@phosphor-icons/react";

export default function Register() {
  const { register } = useAuth();
  const nav = useNavigate();
  const [form, setForm] = useState({ name: "", email: "", password: "", whatsapp_number: "" });
  const [busy, setBusy] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    if (form.password.length < 6) {
      toast.error("Password minimal 6 karakter");
      return;
    }
    setBusy(true);
    try {
      await register(form);
      toast.success("Akun berhasil dibuat!");
      nav("/dashboard");
    } catch (err) {
      toast.error(formatApiError(err.response?.data?.detail) || "Gagal mendaftar");
    } finally {
      setBusy(false);
    }
  };

  return (
    <div className="min-h-screen bg-[#FDFBF7] flex items-center justify-center px-6 py-12">
      <div className="w-full max-w-md">
        <Link to="/" className="inline-flex items-center gap-2 font-bold mb-6" data-testid="register-back-link">
          <ArrowLeft size={18} weight="bold" /> Kembali
        </Link>
        <div className="nb-card nb-card-lg p-8">
          <div className="flex items-center gap-2 mb-6">
            <div className="w-10 h-10 bg-[#A7E4C0] border-2 border-[#121212] rounded-lg flex items-center justify-center">
              <ChatCircleDots size={22} weight="bold" />
            </div>
            <span className="font-display font-black text-2xl">Layanan lainnya RS Mulya</span>
          </div>
          <h1 className="font-display font-black text-3xl tracking-tight">Daftar Gratis</h1>
          <p className="text-[#4A4A4A] mt-1">Mulai terima pesanan via WhatsApp dalam 2 menit.</p>

          <form onSubmit={submit} className="mt-6 space-y-4">
            <div>
              <label className="nb-label">Nama / Nama Bisnis</label>
              <input
                type="text" required className="nb-input"
                placeholder="Warung Bu Ani"
                value={form.name}
                onChange={(e) => setForm({ ...form, name: e.target.value })}
                data-testid="register-name-input"
              />
            </div>
            <div>
              <label className="nb-label">Email</label>
              <input
                type="email" required className="nb-input"
                placeholder="nama@email.com"
                value={form.email}
                onChange={(e) => setForm({ ...form, email: e.target.value })}
                data-testid="register-email-input"
              />
            </div>
            <div>
              <label className="nb-label">Nomor WhatsApp (untuk terima pesanan)</label>
              <input
                type="tel" required className="nb-input"
                placeholder="628123456789"
                value={form.whatsapp_number}
                onChange={(e) => setForm({ ...form, whatsapp_number: e.target.value })}
                data-testid="register-whatsapp-input"
              />
              <p className="text-xs text-[#4A4A4A] mt-1">Format internasional tanpa + (mis. 628…)</p>
            </div>
            <div>
              <label className="nb-label">Password (min. 6 karakter)</label>
              <input
                type="password" required minLength={6} className="nb-input"
                placeholder="••••••••"
                value={form.password}
                onChange={(e) => setForm({ ...form, password: e.target.value })}
                data-testid="register-password-input"
              />
            </div>
            <button type="submit" disabled={busy} className="nb-btn nb-btn-primary w-full justify-center" data-testid="register-submit-button">
              {busy ? "Memproses…" : "Buat Akun"}
            </button>
          </form>

          <p className="text-sm text-center mt-6 text-[#4A4A4A]">
            Sudah punya akun?{" "}
            <Link to="/login" className="font-bold underline" data-testid="register-login-link">Masuk</Link>
          </p>
        </div>
      </div>
    </div>
  );
}
